import { formatShopifyConnectionResource } from "areas/verifications/helpers/shopify";
import { Shopify } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const loginUrl = "https://accounts.shopify.com/lookup"

const shopify: IIngestionSourceData = {
  displayName: "Shopify",
  isEcom: true,
  isAutomated: true,
  parsedDataFormatter: formatShopifyConnectionResource,
  loginUrl,
  inventoryReminder: {
    buttonText: "OK, I will adjust my inventory",
    text: "Don't forget to adjust your Shopify inventory to reflect this Max Retail sale!",
    titleText: "Shopify Inventory Reminder",
    linkText: "Shopify Dashboard",
    linkHref: loginUrl
  },
  listInventory: {
    linkHref: loginUrl,
    icon: Shopify
  },
  cannotUpdateListing: {
    text: `To update this item, you need to edit it in your Shopify account.`,
    linkHref: loginUrl
  },
  listingsSubheader: {
    text: `You're connected to Shopify! While you can view your listings here, you can only make changes in your Max
        Retail collection via `,
    linkHref: loginUrl
  },
  errorReport: {
    getFixLinkHref: (productId: string) => `https://admin.shopify.com/products/${productId}`,
    listHref: "https://admin.shopify.com/products/new"
  }
};

export default shopify